import React from 'react';
import IbssTextField from "../../../../Components/Inputs/TextField/IbssTextField";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";
import { appContext } from "../../../../AppContext";
import IbssInputDropDown from "../../../../Components/Inputs/SelectList/IbssInputDropDown";
import IbssDatePicker from '../../../../Components/Inputs/DatePicker/IbssDatePicker';
import { DateTime } from 'luxon';
import MediaSelector, { IFile } from '../../../../Components/DialogLaunchers/MediaSelector/MediaSelector';
import { Box, FormControl, Typography } from '@mui/material';
import IbssSwitchLabel from '../../../../Components/Inputs/Switch/IbssSwitchLabel';

class QuickLinkForm extends IbssComponent<IProps, IState>
{
    private labels = appContext().labels;
    private applicationTypeOptions: IDropDownOption[];

    constructor(props: IProps)
    {
        super(props);
        this.applicationTypeOptions = [
            {
                label: this.labels.funcFlex_S,
                value: applicationType.flex
            },
            {
                label: this.labels.funcRoamer_S,
                value: applicationType.roamer
            },
            {
                label: this.labels.funcFlexRoamer_S,
                value: applicationType.flexAndRoamer
            }
        ]
    }

    private startDateChange(date: DateTime | null): void
    {
        if (!date || !date.isValid)
        {
            return;
        }
        this.props.onStartDateChange(date);
    }

    private endDateChange(date: DateTime | null): void
    {
        if (!date || !date.isValid)
        {
            return;
        }
        this.props.onEndDateChange(date);
    }

    public render(): JSX.Element
    {
        const toDateFieldError = this.props.endDate && this.props.startDate ? this.props.endDate < this.props.startDate : false;
        const { showErrors, errorFields, application } = this.props;
        const startDateError = showErrors && errorFields.startDate;
        const endDateError = showErrors && errorFields.endDate;
        const isFlexSelected = application.contains(this.labels.funcFlex_S);
        const isRoamerSelected = application.contains(this.labels.funcRoamer_S);
        const isFlexAndRoamer = isFlexSelected && isRoamerSelected;
        return (
            <div>
                <IbssInputDropDown
                    id="applications"
                    inputLabel={this.labels.funcQuickLinkApplications_S}
                    options={this.applicationTypeOptions}
                    value={isFlexAndRoamer ? applicationType.flexAndRoamer : application[0]}
                    onChange={(e) => this.props.onApplicationTypeChange(e.target.value)}
                    error={showErrors && errorFields.applications}
                    helperText={showErrors && errorFields.applications ? this.labels.funcApplicationRequired_L : ' '}
                    required
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcHeading_S}
                    value={this.props.heading}
                    onChange={(e) => this.props.onHeadingChange(e.target.value.trimStart())}
                    margin="normal"
                    maxLength={50}
                    required
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcSubHeading_S}
                    value={this.props.subHeading}
                    onChange={(e) => this.props.onSubHeadingChange(e.target.value)}
                    margin="normal"
                    sx={{ mb: 2 }}
                    maxLength={50}
                />
                <IbssInputDropDown
                    id="quicklink-order-dropdown"
                    sx={{ mt: 2 }}
                    fullWidth
                    inputLabel={this.labels.funcQuickLinkOrder_S}
                    value={this.props.selectedQuickLinkOrder}
                    onChange={(e) => this.props.onQuickLinkOrderChange?.(e.target.value)}
                    options={this.props.signpostOrder.map(order => ({
                        value: order,
                        label: order
                    }))}
                />
                <Box>
                    <Box>
                        <Typography variant="h6" fontWeight={'normal'} mb={1}>{this.labels.funcChooseImage_S}</Typography>
                        <Typography variant="body1" className="ui-text-light">{this.labels.funcUploadAnImageInfo_D}</Typography>
                    </Box>
                    <Box className="option-box" my={2}>
                        <Box mt={2} display={'flex'} justifyContent={"space-between"}>
                            <Typography variant="body1">
                                <MediaSelector
                                    options={this.props.images.map(i => ({ name: i.name, url: i.path }))}
                                    imageSelected={file => this.props.onImageSelect(file.url)}
                                    uploadFile={(filename, file, processAsMap) => this.props.onImageUpload(filename, file, processAsMap)}
                                    defaultSelectedImage={this.props.imageUrl}
                                />
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box>
                    <FormControl fullWidth>
                        <IbssDatePicker
                            sx={{ mt: 2 }}
                            value={this.props.startDate}
                            onChange={(date) => this.startDateChange(date)}
                            label={this.labels.HubLabelFromDate}
                            slotProps={{ textField: { error: startDateError || toDateFieldError, helperText: startDateError ? this.labels.funcStartDateRequired_L : (toDateFieldError ? this.labels.HubLabelStartDateMustBeBeforeTheEndDate : ' ') } }}
                            disabled={this.props.datesDisabled}
                            minDate={this.props.startDate}
                        />
                    </FormControl>
                </Box>
                <Box>
                    <FormControl fullWidth>
                        <IbssDatePicker
                            value={this.props.endDate}
                            onChange={(date) => this.endDateChange(date)}
                            label={this.labels.HubLabelToDate}
                            slotProps={{ textField: { error: endDateError || toDateFieldError, helperText: endDateError ? this.labels.funcEndDateRequired_L : (toDateFieldError ? this.labels.funcEndDate_D : ' ') } }}
                            disabled={this.props.datesDisabled}
                            minDate={this.props.startDate}
                        />
                    </FormControl>

                </Box>
                <IbssTextField
                    fullWidth
                    label="Link Label"
                    value={this.props.labelLink}
                    onChange={(e) => this.props.onLabelLinkChange(e.target.value.trimStart())}
                    margin="normal"
                    required
                    maxLength={50}
                />
                {isFlexSelected && (
                <IbssTextField
                    fullWidth
                    label={this.labels.funcDestinationHTML_S}
                    value={this.props.destinationWeb}
                    onChange={(e) => this.props.onDestinationWebChange(e.target.value)}
                    margin="normal"
                    error={showErrors && errorFields.destinationWeb}
                    helperText={showErrors && errorFields.destinationWeb ? this.labels.funcDestinationHTMLRequired_L : ' '}
                    required={isFlexSelected && !isRoamerSelected}
                />
                )}
                {isRoamerSelected && (
                <div>
                <IbssTextField
                    fullWidth
                    label={this.labels.funcDestinationAndroid_S}
                    value={this.props.destinationAndroid}
                    onChange={(e) => this.props.onDestinationAndroidChange(e.target.value)}
                    margin="normal"
                    error={showErrors && errorFields.destinationAndroid}
                    helperText={showErrors && errorFields.destinationAndroid ? this.labels.funcDestinationAndroidRequired_L : ' '}
                    required={isRoamerSelected && !isFlexSelected}
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcDestinationIOS_S}
                    value={this.props.destinationIOS}
                    onChange={(e) => this.props.onDestinationIosChange(e.target.value)}
                    margin="normal"
                    error={showErrors && errorFields.destinationIOS}
                    helperText={showErrors && errorFields.destinationIOS ? this.labels.funcDestinationIOSRequired_L : ' '}
                    required={isRoamerSelected && !isFlexSelected}
                />
                </div>
                )}
                <IbssSwitchLabel
                    checked={this.props.isEnabled === 1 ? true : false}
                    onChange={e => this.props.onStatusChange(e.target.checked)}
                    label={this.labels.HubLabelActive}
                />
            </div>
        )
    }

}

export default QuickLinkForm;

interface IProps
{
    heading: string;
    onHeadingChange: (value: string) => void;
    subHeading: string
    onSubHeadingChange: (value: string) => void;
    destinationWeb: string
    onDestinationWebChange: (value: string) => void;
    destinationAndroid: string;
    onDestinationAndroidChange: (value: string) => void;
    destinationIOS: string;
    onDestinationIosChange: (value: string) => void;
    application: string[],
    onApplicationTypeChange: (value: string) => void;
    labelLink: string
    onLabelLinkChange: (value: string) => void;
    signpostOrder: string[];
    selectedQuickLinkOrder: string;
    onQuickLinkOrderChange: (value: string) => void;
    startDate: DateTime;
    onStartDateChange: (date: DateTime) => void;
    endDate: DateTime;
    onEndDateChange: (date: DateTime) => void;
    datesDisabled: boolean,
    images: IFile[];
    showErrors: boolean;
    errorFields: IErroredFields;
    onImageSelect: (image: string) => void;
    imageUrl: string
    onIconSelect: (url: string) => void;
    onImageUpload: (filename: string, file: FormData, processAsMap: boolean) => Promise<void>;
    isEnabled: number;
    onStatusChange: (value: boolean) => void;
}
export interface IErroredFields
{
    applications: boolean;
    startDate: boolean;
    endDate: boolean;
    destinationWeb: boolean;
    destinationAndroid: boolean;
    destinationIOS: boolean;
}
export interface IDropDownOption
{
    label: string;
    value: string;
}
export interface IState{}

export enum applicationType
{
    flex = "Flex",
    roamer = "Roamer",
    flexAndRoamer = "Flex and Roamer"
}
